module.exports = __webpack_public_path__ + "static/media/app-error-monsters.71508cba.png";